<template>
  <layout-breadcrumb-cartao
    titulo="Validação de PTU"
    :breadcrumb="bread"
    :iconeSvg="ValidacaoSvg"
  >
    <TabelaValidacao />
  </layout-breadcrumb-cartao>
</template>

<script>
/* eslint-disable */
import TabelaValidacao from "./shared/componentes/TabelaValidacao";

export default {
  components: {
    TabelaValidacao
  },
  data() {
    return {
      arrTexto: [],
      bread: [
        { titulo: "Início", url: "/home" },
        { titulo: "Validação de PTU" }
      ]
    };
  }
};
</script>
